import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { User } from './types/User';

interface UserApiV2Response {
  users: User[];
}

const getUsers = (makeCall: MakeCall) => (uuids: string[]) =>
  makeCall<UserApiV2Response>('POST', `/api/v2/users`, {
    data: { uuids },
  });

export default getUsers;
